module.exports = __webpack_public_path__ + "img/ic_dc.8524e6ff.svg";